module.exports = __webpack_public_path__ + "img/gateway.de126bdc.svg";